export const ALL_URLS = {
  development: {
    API_URL: 'http://localhost:4000',
    LOGIN_URL: 'http://localhost:7070',
    TERMS_URL: 'https://legal.arcadia.com',
    WEBSOCKET_URL: 'ws://localhost:4000',
    AMEREN_URL:
      'https://login.ciam-dev.ece.ameren.com/oauth2/realms/root/realms/offlineaccess/authorize?response_type=code&client_id=68d8f07d-2e88-4f6e-816c-3fa2ea2fc64b',
    LMI_POWERFORM_URL:
      'https://demo.docusign.net/Member/PowerFormSigning.aspx?PowerFormId=e57e81ad-61f3-4f97-804a-1a631b88f3fb&env=demo&acct=f6250ad6-1c96-47ff-a471-e02fcb991e81&v=2',
    ARCADIA_REWARDS_URL: 'https://www.dev.arcadiarewards.com/',
  },
  production: {
    API_URL: 'https://gryphon.arcadia.com',
    LOGIN_URL: 'https://login.arcadia.com',
    TERMS_URL: 'https://legal.arcadia.com',
    WEBSOCKET_URL: 'wss://gryphon.arcadia.com',
    AMEREN_URL:
      'https://login.eiam.ece.ameren.com:443/oauth2/realms/root/realms/offlineaccess/authorize?response_type=code&client_id=9a504672-77d4-4ed1-86d1-662d023ebaf5',
    LMI_POWERFORM_URL:
      'https://na2.docusign.net/Member/PowerFormSigning.aspx?PowerFormId=f5cad373-c1ac-474e-a9cb-05fb1b378643&env=na2&acct=6994e7bf-62ef-431a-af4e-739e5dc15cb9&v=2',
    ARCADIA_REWARDS_URL: 'https://www.arcadiarewards.com/',
  },
  staging: {
    API_URL: 'https://staging.gryphon.arcadia.com',
    LOGIN_URL: 'https://staging.sphinx.arcadia.com',
    TERMS_URL: 'https://staging.catbird.arcadia.com',
    WEBSOCKET_URL: 'wss://staging.gryphon.arcadia.com',
    AMEREN_URL:
      'https://login.ciam-dev.ece.ameren.com/oauth2/realms/root/realms/offlineaccess/authorize?response_type=code&client_id=68d8f07d-2e88-4f6e-816c-3fa2ea2fc64b',
    LMI_POWERFORM_URL:
      'https://demo.docusign.net/Member/PowerFormSigning.aspx?PowerFormId=e57e81ad-61f3-4f97-804a-1a631b88f3fb&env=demo&acct=f6250ad6-1c96-47ff-a471-e02fcb991e81&v=2',
    ARCADIA_REWARDS_URL: 'https://www.dev.arcadiarewards.com/',
  },
};
